//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';

export class RepertoirePerformanceDisplayItem extends ItemBase {
    RepertoirePerformanceID: string | null = null;
    StudentID: string | null = null;
    Student: StudentNameDisplayItem | null = null;
    RepertoireID: string | null = null;
    Event: string | null = null;
    Grade: string | null = null;
    Note: string | null = null;
    PerformanceDate: string = "1970-01-01T00:00:00";

    constructor(initializer?: Partial<RepertoirePerformanceDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RepertoirePerformanceDisplayItem";
}
